import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useSrShiftBasedAssignmentEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.SrShiftBasedAssignment, false);

  return Boolean(isEnabled);
}
